/**
 * @module store/stats/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает объект поддерживаемых токенов
 *
 * @returns {object}
 */
const stats = state => state.stats;


/**
 * Getter: Возвращает флаг загружается ли статистика в текущий момент
 *
 * @returns {boolean}
 */
const isStatsLoading = state => state.isStatsLoading;

export default {
  isStatsLoading,
  stats,
};
